<template>
    <div class="headerBox">
        <div class="headerContent">
            <div class="logo" @click="backHome">
                <img src="@/assets/logo.png">
            </div>
            <img class="menuImg" src="@/assets/menu.png" @click="openMenu" v-if="!drawerVisible" alt="">
            <img class="menuImg" src="@/assets/closeMenu.png" @click="closeMenu" v-if="drawerVisible" alt="">
        </div>
        <el-drawer :visible.sync="drawerVisible" direction="rtl" :with-header="false" size="50%">
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" style="padding-top: 80px;">
					<div v-for="(item) in pathList" :key="item.souy">
						<el-menu-item :index="item.souy" v-if="!item.child" @click="handleSelect(item.path)">
                        <template slot="title"><span class="font16">{{item.name}}</span></template>
                    </el-menu-item>
						<el-submenu v-if="item.child" :index="item.souy">
							<template slot="title">{{item.name}}</template>
							<el-menu-item :index="itemd.souy" v-for="(itemd) in item.child" :key="itemd.souy" @click="handleSelect(itemd.path)">{{itemd.name}}</el-menu-item>
						</el-submenu>
					</div>
				</el-menu>
        </el-drawer>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            activeIndex: '1',
            drawerVisible:false,
            pathList:[
                {
						name:"首页",
						path:'/index',
						souy:'1'
					},
                {
						name:"关于瑞和",
						path:'/aboutUs',
						souy:'2',
                    child:[
                        {
                            name:'公司简介',
                            path:'/aboutUs/Introduction',
                            souy:'2-1'
                        },
                        {
                            name:'企业文化',
                            path:'/aboutUs/CorporateCulture',
                            souy:'2-2'
                        },
                        {
                            name:'资信荣誉',
                            path:'/aboutUs/AwardsAndHonors',
                            souy:'2-3'
                        },
                        {
                            name:'典型业绩',
                            path:'/aboutUs/TypicalPerformance',
                            souy:'2-4'
                        },
                        {
                            name:'专家团队',
                            path:'/aboutUs/ExpertTeam',
                            souy:'2-5'
                        },
                        {
                            name:'知识成果',
                            path:'/aboutUs/SocialValue',
                            souy:'2-6'
                        },
                        {
                            name:'党工妇团',
                            path:'/aboutUs/workWomenCorps',
                            souy:'2-7'
                        }
                    ]
					},
                {
                    name:'业务范围',
                    path:'/businessScope',
                    souy:'3',
                    child:[
                        {
                            name:'全咨业务',
                            path:'/businessScope/consultationBusiness',
                            souy:'3-1'
                        },
                        {
                            name:'招标采购',
                            path:'/businessScope/biddingAgent',
                            souy:'3-2'
                        },
                        {
                            name:'投资咨询',
                            path:'/businessScope/earlierConsultation',
                            souy:'3-3'
                        },
                        {
                            name:'造价咨询',
                            path:'/businessScope/costConsultation',
                            souy:'3-4'
                        },
                        {
                            name:'管理咨询',
                            path:'/businessScope/projectManagement',
                            souy:'3-5'
                        },
                        {
                            name:'数字化应用',
                            path:'/businessScope/BIMApplication',
                            souy:'3-6'
                        }
                    ]
                },
                {
                    name:'职业发展',
                    path:'/humanResources',
                    souy:'4',
                    child:[
                        {
                            name:'人才招聘',
                            path:'/humanResources/job',
                            souy:'4-1'
                        },
                        {
                            name:'团队活动',
                            path:'/humanResources/GroupActivities',
                            souy:'4-2'
                        }
                    ]
                },
                {
                    name:'合作共赢',
                    path:'/cooperate/Index',
                    souy:'5'
                },
                {
                    name:'媒体中心',
                    path:'/mediaCenter',
                    souy:'6',
                    child:[
                        {
                            name:'行业资讯',
                            path:'/mediaCenter/IndustryNews',
                            souy:'6-1'
                        },
                        {
                            name:'企业动态',
                            path:'/mediaCenter/CompanyNews',
                            souy:'6-2'
                        },
                        {
                            name:'公告',
                            path:'/mediaCenter/Notice',
                            souy:'6-3'
                        },
                        {
                            name:'公示',
                            path:'/mediaCenter/Public',
                            souy:'6-4'
                        },
                        {
                            name:'澄清与修改',
                            path:'/mediaCenter/Clarify',
                            souy:'6-5'
                        },
                        {
                            name:'公众参与公示',
                            path:'/mediaCenter/NoticePub',
                            souy:'6-6'
                        }
                    ]
                },
                {
                    name:'联系我们',
                    path:'/linkUs',
                    souy:'7',
                    child:[
                        {
                            name:'联系方式',
                            path:'/linkUs/ContactUs',
                            souy:'7-1'
                        },
                        {
                            name:'反馈中心',
                            path:'/linkUs/FeedBack',
                            souy:'7-2'
                        }
                    ]
                }
            ]
        };
    },
    watch: {
        $route: {
            handler(value){
                // 初始化activeIndex
                let path = value.path.split('/')
                this.checkNav(path)
            },
            immediate: true
        }
    },
    mounted(){
        let path = this.$route.path.split('/')
        this.checkNav(path)
    },
    methods: {

        // 判断导航选中
        checkNav(path){
            var list= this.pathList
            for(var i=0;i<list.length;i++){
                if(!list[i].child){
                    if(list[i].path.indexOf(path[path.length-1])!=-1){
                        this.activeIndex = list[i].souy
                    }
                }
                if(list[i].child){
                    var item = list[i].child
                    for(var j=0;j<item.length;j++){
                        if(item[j].path.indexOf(path[path.length-1])!=-1){
                            this.activeIndex = item[j].souy
                        }
                    }
                    //知识成果
                    if(path[path.length-1]=='SocialValueList'||path[path.length-1]=='SocialValueInfo'){
                        this.activeIndex ='2-5'
                    }
                    // 人才招聘
                    if(path[path.length-1]=='resume'){
                        this.activeIndex ='4-1'
                    }
                    //媒体中心
                    if(path[path.length-1]=='IndustryNewsDetails'){ //行业资讯
                        this.activeIndex ='6-1'
                    }
                    if(path[path.length-1]=='CompanyNewsDetails'){ //企业动态
                        this.activeIndex ='6-2'
                    }
                    if(path[path.length-1]=='NoticeDetails'){ //公告
                        this.activeIndex ='6-3'
                    }
                    if(path[path.length-1]=='PublicDetails'){ //公示
                        this.activeIndex ='6-4'
                    }
                    if(path[path.length-1]=='ClarifyDetails'){ //澄清与修改
                        this.activeIndex ='6-5'
                    }
                    if(path[path.length-1]=='NoticePubDetails'){ //公众参与公示
                        this.activeIndex ='6-6'
                    }
                }
            }
        },

       //回到首页
       backHome(){
        this.$router.push({
            path:'/index'
        })
       },

       //导航切换
       handleSelect(keypath){
        this.$router.push({
            path:keypath
        })
        this.drawerVisible = false
       },

       //打开导航菜单
       openMenu(){
        this.drawerVisible= true
       },
       //关闭导航菜单
       closeMenu(){
        this.drawerVisible = false
       }
    }
}
</script>

<style lang="less" scoped>

.headerContent {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
        img {
            height: 60px;
            width: auto;
            margin-top: 5px;
        }
    }
}
.menuImg{
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
</style>
